export default __webpack_public_path__ + "static/media/trackingProducts.2eb2d980.jpg";